import { DSR_ACCESS_TOKEN } from "@/store/constants/global";
import { getDiariesApi, getDiaryById } from "@/api/DiaryApi";
import { getSitesApi, getCo2Input, getMetaDataSite } from "@/api/SiteApi";
import { getMe } from "@/api/ProfileApi";
import { findDiaryIdLatest } from "@/services/GlobalServices";
import {
  compareEditDateTimeDesc,
  compareDiaryDateAsc,
} from "@/services/GlobalServices";
import { resetSignsDiaryBeforeCopy } from "@/services/DiaryListServices";
import DiaryListInternalData from "@/internalData/DiaryList";
import moment from "moment";
import _ from "lodash";
// initial state
const state = () => ({
  name: "",
  appRole: null,
  siteSelected: null,
  calendarDate: moment(new Date()),
  sites: [],
  totalSites: null,
  diaryEditing: [], //diary in current month in calendar
  diaryEditingCopyModal: [], //diary in current month in calendar
  diaries: [],
  co2Input: co2InputDefault(),
  diaryIdLatest: "",
  diaryLatest: {},
  stateCopyFunction: true,
  metaDataSite: {},
  isLoadingDiaryEditing: false, // カレンダー読み込み状態
});

// getters
const getters = {
  getSites: (state) => {
    return state.sites;
  },
  getTotalSites: (state) => {
    return state.totalSites;
  },
  getSiteSelected: (state) => {
    return state.siteSelected;
  },
  getCalendarDate: (state) => {
    return state.calendarDate;
  },
  getDiariesEditing: (state) => {
    return state.diaryEditing;
  },
  getDiariesEditingCopyModal: (state) => {
    return state.diaryEditingCopyModal;
  },
  getDiaries: (state) => {
    return state.diaries;
  },
  getCo2Input: (state) => {
    return state.co2Input;
  },
  getName: (state) => {
    return state.name;
  },
  getAppRole: (state) => {
    return state.appRole;
  },
  getDiaryIdLatest: (state) => {
    return state.diaryIdLatest;
  },
  getDiaryLatest: (state) => {
    return state.diaryLatest;
  },
  getStateCopyFunction: (state) => {
    return state.stateCopyFunction;
  },
  getMetaDataSite: (state) => {
    return state.metaDataSite;
  },
  getIsLoadingDiaryEditing: (state) => {
    return state.isLoadingDiaryEditing;
  },
};

// actions
const actions = {
  async getSiteRecords({ commit }) {
    console.log(`getSiteRecords`);
    const accessToken = localStorage.getItem(DSR_ACCESS_TOKEN);
    const contractorToken = localStorage.getItem('contractor_token');
    
    // Auth0トークンまたは契約社員トークンのいずれかが存在する場合にAPI呼び出し
    if (accessToken || contractorToken) {
      getSitesApi().then((response) => {
        commit("setSiteRecords", response.data);
      });
    } else {
      console.warn('認証トークンが見つかりません');
    }
  },
  async getDiariesRecords({ commit }, data) {
    getDiariesApi(data).then((response) => {
      commit("setDiariesRecords", response.data.result);
    });
  },
  async getDiariesEditingRecords({ commit }, data) {
    commit("setLoadingDiaryEditing", true);
    getDiariesApi(data).then((response) => {
      commit("setDiariesEditingRecords", response.data.result);
      commit("setLoadingDiaryEditing", false);
    }).catch((error) => {
      commit("setLoadingDiaryEditing", false);
      throw error;
    });
  },
  async getDiariesEditingRecordsCopyModal({ commit }, data) {
    getDiariesApi(data).then((response) => {
      commit("setDiariesEditingRecordsCopyModal", response.data.result);
    });
  },
  getCo2Input({ commit }, { siteId }) {
    getCo2Input(siteId).then((response) => {
      const { result } = response.data;
      commit("setCo2Input", result);
    });
  },
  getMeRecord({ commit }) {
    getMe().then((response) => {
      commit("setName", response.data);
    });
  },
  async getDiaryDetail({ commit, state }) {
    console.log("📖 getDiaryDetail - diaryIdLatest:", state.diaryIdLatest);
    const response = await getDiaryById(state.diaryIdLatest);
    const diaryLatest = response.data.result;
    console.log("📖 getDiaryDetail - API response:", diaryLatest);
    console.log("📖 getDiaryDetail - workRecords in response:", diaryLatest.workRecords);
    commit("setDiaryLatest", diaryLatest);
  },
  async getMetaDataSite({ commit }, { siteId }) {
    await getMetaDataSite(siteId).then((response) => {
      const metaDataFromSite = response.data;
      metaDataFromSite.siteId = siteId;
      commit("setMetaDataSite", metaDataFromSite);
    });
  },
};

// mutations
const mutations = {
  setSiteRecords(state, data) {
    state.sites = serializerSiteRecords(data);
    state.totalSites = data.total;
  },
  setSiteSelected(state, obj) {
    state.siteSelected = obj.site;
  },
  setCalendarDate(state, obj) {
    state.calendarDate = obj.date;
  },
  setDiariesRecords(state, data) {
    let diaries = serializerDiariesRecords(data);
    state.diaries = diaries;
    state.diaryIdLatest = findDiaryIdLatest(diaries);
  },
  setDiaryLatest(state, diary) {
    if (diary) {
      console.log("💾 setDiaryLatest - Setting diary:", diary);
      console.log("💾 setDiaryLatest - workRecords:", diary.workRecords);
      state.diaryLatest = diary;
    }
  },
  setStateCopyFunction(state, status) {
    state.stateCopyFunction = status;
  },
  setDiariesEditingRecords(state, data) {
    state.diaryEditing = serializerDiariesEditingRecords(data);
  },
  setDiariesEditingRecordsCopyModal(state, data) {
    state.diaryEditingCopyModal = serializerDiariesEditingRecords(data);
  },
  setCo2Input(state, data) {
    state.co2Input = serializerCo2Input(data);
  },
  updateStateCo2InputElectricity(state, obj) {
    if (["utilizationOfElectricityMenus"].includes(obj.subAttr)) {
      return _.set(
        state.co2Input.electricity,
        [obj.subAttr, "amount.value"].join("."),
        obj.value
      );
    } else if (
      ["year", "month", "amount.value", "cost.value"].includes(obj.subAttr)
    ) {
      return _.set(
        state.co2Input.electricity.utilizationOfElectricityMenus.monthlyUses?.[
          obj.index
        ],
        obj.subAttr,
        obj.value
      );
    }
    _.set(state.co2Input.electricity, obj.subAttr, obj.value);
  },
  updateStateCo2InputAlterNativeFuel(state, obj) {
    _.set(
      state.co2Input.othersMonthlyUses?.alterNativeFuel?.[obj.index],
      obj.subAttr,
      obj.value
    );
  },
  AddAlterNativeFuel(state, obj) {
    if (!state.co2Input.othersMonthlyUses) {
      const initOthersMonthlyUses = {
        alterNativeFuel: [],
        alterNativeEnergy: [],
      };
      const newCO2Input = {
        ...state.co2Input,
        othersMonthlyUses: initOthersMonthlyUses,
      };
      _.set(state, "co2Input", newCO2Input);
    }
    let alterNativeFuelState =
      state.co2Input.othersMonthlyUses?.alterNativeFuel ?? [];
    alterNativeFuelState.push(obj);
    _.set(
      state.co2Input.othersMonthlyUses,
      "alterNativeFuel",
      alterNativeFuelState
    );
  },
  updateStateCo2InputAlterNativeEnergy(state, obj) {
    _.set(
      state.co2Input.othersMonthlyUses?.alterNativeEnergy?.[obj.index],
      obj.subAttr,
      obj.value
    );
  },
  AddAlterNativeEnergy(state, obj) {
    if (!state.co2Input.othersMonthlyUses) {
      const initOthersMonthlyUses = {
        alterNativeFuel: [],
        alterNativeEnergy: [],
      };
      const newCO2Input = {
        ...state.co2Input,
        othersMonthlyUses: initOthersMonthlyUses,
      };
      _.set(state, "co2Input", newCO2Input);
    }
    let alterNativeEnergyState =
      state.co2Input.othersMonthlyUses?.alterNativeEnergy ?? [];
    alterNativeEnergyState.push(obj);
    _.set(
      state.co2Input.othersMonthlyUses,
      "alterNativeEnergy",
      alterNativeEnergyState
    );
  },
  addElectricity(state, obj) {
    if (!state.co2Input.electricity.utilizationOfElectricityMenus.monthlyUses) {
      const newUtilizationOfElectricityMenus = {
        ...state.co2Input.electricity.utilizationOfElectricityMenus,
        monthlyUses: [],
      };
      _.set(
        state.co2Input.electricity,
        "utilizationOfElectricityMenus",
        newUtilizationOfElectricityMenus
      );
    }
    let electricityState =
      state.co2Input.electricity.utilizationOfElectricityMenus.monthlyUses ??
      [];
    electricityState.push(obj);
    _.set(
      state.co2Input.electricity.utilizationOfElectricityMenus,
      "monthlyUses",
      electricityState
    );
  },
  addCementAlterNative(state, obj) {
    if (!state.co2Input.others.useOfCementAlternative.monthlyUses) {
      const initCementState = {
        ...state.co2Input.others.useOfCementAlternative,
        monthlyUses: [],
      };
      _.set(state.co2Input.others, "useOfCementAlternative", initCementState);
    }
    let cementState =
      state.co2Input.others.useOfCementAlternative.monthlyUses ?? [];
    cementState.push(obj);
    _.set(
      state.co2Input.others.useOfCementAlternative,
      "monthlyUses",
      cementState
    );
  },
  updateStateCo2InputCementAlternative(state, obj) {
    _.set(
      state.co2Input.others.useOfCementAlternative?.monthlyUses?.[obj.index],
      obj.subAttr,
      obj.value
    );
  },
  updateStateCo2InputKerosene(state, obj) {
    _.set(state.co2Input.kerosene, obj.subAttr, obj.value);
  },
  updateStateCo2InputDiesel(state, obj) {
    _.set(state.co2Input.diesel, obj.subAttr, obj.value);
  },
  updateStateCo2InputHeavyOil(state, obj) {
    _.set(state.co2Input.heavyOil, obj.subAttr, obj.value);
  },
  updateStateCo2InputOthers(state, obj) {
    if (
      [
        "useOfB5",
        "useOfB100",
        "useGTLFuel",
        "installSolarPanelsOnSite",
      ].includes(obj.subAttr)
    ) {
      _.set(
        state.co2Input.others,
        [obj.subAttr, "amount.value"].join("."),
        obj.value
      );
    } else if (["installWindPowerGenerationOnSite"].includes(obj.subAttr)) {
      _.set(
        state.co2Input.others,
        [obj.subAttr, "usage.value"].join("."),
        obj.value
      );
    } else if ("useOfCementAlternative" === obj.subAttr) {
      _.set(
        state.co2Input.others.useOfCementAlternative,
        [obj.subAttr, "usage.value"].join("."),
        obj.value
      );
    } else {
      _.set(state.co2Input.others, obj.subAttr, obj.value);
    }
  },
  updateStateCo2InputWater(state, obj) {
    if (["waterIntake", "drainageDestination"].includes(obj.subAttr)) {
      _.set(
        state.co2Input.water,
        [obj.subAttr, obj.typeMeasure, "value"].join("."),
        obj.value
      );
    }
  },
  updateStateCo2SelectionWater(state, obj) {
    if (["waterIntake", "drainageDestination"].includes(obj.subAttr)) {
      _.set(state.co2Input.water, `${obj.subAttr}.type`, obj.value);
      _.set(
        state.co2Input.water,
        `${obj.subAttr}.isUsed`,
        obj.value === DiaryListInternalData.waterIntakeMenus[7].value
      );
      if (obj.value !== DiaryListInternalData.waterIntakeMenus[7].value) {
        _.set(state.co2Input.water, `${obj.subAttr}.otherType`, "");
      }
    }
  },
  updateStateCo2Selection(state, obj) {
    if (["utilizationOfElectricityMenus"].includes(obj.subAttr)) {
      _.set(state.co2Input.electricity, `${obj.subAttr}.type`, obj.value);
      _.set(
        state.co2Input.electricity,
        `${obj.subAttr}.isUsed`,
        obj.value !==
          DiaryListInternalData.utilizationOfElectricityMenus[0].value
      );
      if (
        obj.value ===
        DiaryListInternalData.utilizationOfElectricityMenus[0].value
      ) {
        _.set(state.co2Input.electricity, `${obj.subAttr}.amount.value`, "");
      }
    }
  },
  setCo2InputOrderUsed(state, obj) {
    _.set(state.co2Input.others, [obj.attr, "isUsed"], obj.value);
  },
  addAmountCo2Input(state, { attr }) {
    const temp = {
      year: "",
      month: "",
      value: "",
      cost: "",
      unit: "",
      isFocusYear: false,
      isValidateYear: true,
      isFocusMonth: false,
      isValidateMonth: true,
      isFocusValue: false,
      isValidateValue: true,
      isFocusCost: false,
      isValidateCost: true,
    };
    if (attr == "electricity") {
      state.co2Input.electricity.amount.push(
        Object.assign(temp, { unit: "kWh", costUnit: "JPY" })
      );
    } else if (attr == "kerosene") {
      state.co2Input.kerosene.amount.push(
        Object.assign(temp, { unit: "L", costUnit: "JPY" })
      );
    } else if (attr == "heavyOil") {
      state.co2Input.heavyOil.amount.push(
        Object.assign(temp, { unit: "L", costUnit: "JPY" })
      );
    } else if (["waterIntake", "drainageDestination"].includes(attr)) {
      state.co2Input.water[attr].amount.push(
        Object.assign(temp, { unit: "L" })
      );
    }
  },
  updateCo2InputAmount(state, obj) {
    switch (obj.attr) {
      // ********* electricity *********
      case "electricity": {
        state.co2Input.electricity.amount[obj.index][obj.subAttr] = obj.value;
        break;
      }
      // ********* kerosene *********
      case "kerosene": {
        state.co2Input.kerosene.amount[obj.index][obj.subAttr] = obj.value;
        break;
      }
      // ********* Heavy Oil *********
      case "heavyOil": {
        state.co2Input.heavyOil.amount[obj.index][obj.subAttr] = obj.value;
        break;
      }
      // ********* Water Intake *********
      case "waterIntake": {
        state.co2Input.water.waterIntake.amount[obj.index][obj.subAttr] =
          obj.value;
        break;
      }
      // ********* Water Intake *********
      case "drainageDestination": {
        state.co2Input.water.drainageDestination.amount[obj.index][
          obj.subAttr
        ] = obj.value;
        break;
      }
      default:
        break;
    }
  },
  deleteCo2InputAmount(state, obj) {
    if (["kerosene", "heavyOil"].includes(obj.attr)) {
      state.co2Input[obj.attr].amount.splice(obj.index, 1);
    } else if (["waterIntake", "drainageDestination"].includes(obj.attr)) {
      state.co2Input.water[obj.attr].amount.splice(obj.index, 1);
    } else if (["alterNativeFuel", "alterNativeEnergy"].includes(obj.attr)) {
      state.co2Input.othersMonthlyUses[obj.attr].splice(obj.index, 1);
    } else if (["electricity"].includes(obj.attr)) {
      if (obj.subAttr) {
        state.co2Input.electricity.amount.splice(obj.index, 1);
      } else {
        state.co2Input.electricity.utilizationOfElectricityMenus.monthlyUses.splice(
          obj.index,
          1
        );
      }
    } else if (["cement"].includes(obj.attr)) {
      state.co2Input.others.useOfCementAlternative.monthlyUses.splice(
        obj.index,
        1
      );
      state.co2Input.others.useOfCementAlternative.isUsed =
        state.co2Input.others.useOfCementAlternative.monthlyUses.length > 0;
    }
  },
  resetDiaryList(state) {
    state.diaries = [];
  },
  resetDiaryListStore(state) {
    state.diaryEditing = [];
    state.diaries = [];
    state.co2Input = co2InputDefault();
    state.metaDataSite = {};
    state.isLoadingDiaryEditing = false;
  },
  setLoadingDiaryEditing(state, isLoading) {
    state.isLoadingDiaryEditing = isLoading;
  },
  setName(state, result) {
    if (result != false) {
      state.name = result.name;
      state.appRole = result.appRole;
    }
  },
  updateStateCO2InputIsFocus(state, { attr, subAttr, index, isFocus }) {
    if (["electricity", "kerosene", "heavyOil"].includes(attr)) {
      _.set(state.co2Input, [attr, "amount", index, subAttr], isFocus);
    }
  },
  updateStateCO2InputIsValidate(state, { attr, subAttr, index, isValidate }) {
    switch (attr) {
      case "electricity": {
        if (subAttr == "year") {
          state.co2Input.electricity.amount[index]["isValidateYear"] =
            isValidate;
        } else if (subAttr == "month") {
          state.co2Input.electricity.amount[index]["isValidateMonth"] =
            isValidate;
        } else if (subAttr == "value") {
          state.co2Input.electricity.amount[index]["isValidateValue"] =
            isValidate;
        } else if (subAttr == "cost") {
          state.co2Input.electricity.amount[index]["isValidateCost"] =
            isValidate;
        }
        break;
      }
      case "utilizationOfElectricityMenus": {
        console.log("JOIN utilizationOfElectricityMenus");
        if (subAttr == "year") {
          state.co2Input.electricity.utilizationOfElectricityMenus.monthlyUses[
            index
          ]["isValidateYear"] = isValidate;
        } else if (subAttr == "month") {
          state.co2Input.electricity.utilizationOfElectricityMenus.monthlyUses[
            index
          ]["isValidateMonth"] = isValidate;
        } else if (subAttr == "amount.value") {
          state.co2Input.electricity.utilizationOfElectricityMenus.monthlyUses[
            index
          ].amount["isValidateValue"] = isValidate;
        } else if (subAttr == "cost.value") {
          state.co2Input.electricity.utilizationOfElectricityMenus.monthlyUses[
            index
          ].cost["isValidateCost"] = isValidate;
        }
        break;
      }
      case "kerosene": {
        if (subAttr == "year") {
          state.co2Input.kerosene.amount[index]["isValidateYear"] = isValidate;
        } else if (subAttr == "month") {
          state.co2Input.kerosene.amount[index]["isValidateMonth"] = isValidate;
        } else if (subAttr == "value") {
          state.co2Input.kerosene.amount[index]["isValidateValue"] = isValidate;
        } else if (subAttr == "cost") {
          state.co2Input.kerosene.amount[index]["isValidateCost"] = isValidate;
        }
        break;
      }
      case "heavyOil": {
        if (subAttr == "year") {
          state.co2Input.heavyOil.amount[index]["isValidateYear"] = isValidate;
        } else if (subAttr == "month") {
          state.co2Input.heavyOil.amount[index]["isValidateMonth"] = isValidate;
        } else if (subAttr == "value") {
          state.co2Input.heavyOil.amount[index]["isValidateValue"] = isValidate;
        } else if (subAttr == "cost") {
          state.co2Input.heavyOil.amount[index]["isValidateCost"] = isValidate;
        }
        break;
      }
      case "waterIntake": {
        if (subAttr == "year") {
          state.co2Input.water.waterIntake.amount[index]["isValidateYear"] =
            isValidate;
        } else if (subAttr == "month") {
          state.co2Input.water.waterIntake.amount[index]["isValidateMonth"] =
            isValidate;
        } else if (subAttr == "value") {
          state.co2Input.water.waterIntake.amount[index]["isValidateValue"] =
            isValidate;
        }
        break;
      }
      case "drainageDestination": {
        if (subAttr == "year") {
          state.co2Input.water.drainageDestination.amount[index][
            "isValidateYear"
          ] = isValidate;
        } else if (subAttr == "month") {
          state.co2Input.water.drainageDestination.amount[index][
            "isValidateMonth"
          ] = isValidate;
        } else if (subAttr == "value") {
          state.co2Input.water.drainageDestination.amount[index][
            "isValidateValue"
          ] = isValidate;
        }
        break;
      }
      case "alterNativeFuel": {
        if (subAttr == "year") {
          state.co2Input.othersMonthlyUses.alterNativeFuel[index][
            "isValidateYear"
          ] = isValidate;
        } else if (subAttr == "month") {
          state.co2Input.othersMonthlyUses.alterNativeFuel[index][
            "isValidateMonth"
          ] = isValidate;
        } else if (subAttr == "amount.value") {
          state.co2Input.othersMonthlyUses.alterNativeFuel[index].amount[
            "isValidateValue"
          ] = isValidate;
        }
        break;
      }
      case "alterNativeEnergy": {
        if (subAttr === "year") {
          state.co2Input.othersMonthlyUses.alterNativeEnergy[index][
            "isValidateYear"
          ] = isValidate;
        } else if (subAttr === "month") {
          state.co2Input.othersMonthlyUses.alterNativeEnergy[index][
            "isValidateMonth"
          ] = isValidate;
        } else if (subAttr === "amount.value") {
          state.co2Input.othersMonthlyUses.alterNativeEnergy[index].amount[
            "isValidateValue"
          ] = isValidate;
        }
        break;
      }
      case "cement": {
        if (subAttr === "year") {
          state.co2Input.others.useOfCementAlternative.monthlyUses[index][
            "isValidateYear"
          ] = isValidate;
        } else if (subAttr === "month") {
          state.co2Input.others.useOfCementAlternative.monthlyUses[index][
            "isValidateMonth"
          ] = isValidate;
        } else if (subAttr === "amount.value") {
          state.co2Input.others.useOfCementAlternative.monthlyUses[
            index
          ].amount["isValidateValue"] = isValidate;
        }
        break;
      }
    }
  },
  updateStateCO2InputIsFocusElectricity(state, { attr, typeMeasure, isFocus }) {
    state.co2Input.electricity[attr][typeMeasure]["isFocus"] = isFocus;
  },
  updateStateCO2InputIsValidateElectricity(
    state,
    { attr, typeMeasure, isValidate }
  ) {
    state.co2Input.electricity[attr][typeMeasure]["isValidate"] = isValidate;
  },
  updateStateCO2InputIsFocusOthers(
    state,
    { attributeOther, typeMeasure, isFocus }
  ) {
    state.co2Input.others[attributeOther][typeMeasure]["isFocus"] = isFocus;
  },
  updateStateCO2InputIsValidateOthers(
    state,
    { attributeOther, typeMeasure, isValidate }
  ) {
    state.co2Input.others[attributeOther][typeMeasure]["isValidate"] =
      isValidate;
  },
  updateStateCO2InputIsFocusWater(
    state,
    { attributeOther, typeMeasure, isFocus }
  ) {
    state.co2Input.water[attributeOther][typeMeasure]["isFocus"] = isFocus;
  },
  updateStateCO2InputIsValidateWater(
    state,
    { attributeOther, typeMeasure, isValidate }
  ) {
    console.log({ attributeOther, typeMeasure, isValidate });
    state.co2Input.water[attributeOther][typeMeasure]["isValidate"] =
      isValidate;
  },
  fixDataCopyDiaryRecord(state, { dateCopyTo, sourceDiary, editor, selectedDiaryPeriod }) {
    try {
      if (dateCopyTo && sourceDiary) {
        // sourceから提供された日誌データを使用
        const copyDiary = _.cloneDeep(sourceDiary);
        console.info("copyDiary", copyDiary);
        console.info("copyDiary.siteID", copyDiary.siteId);
        console.info("copyDiary.workRecords BEFORE processing:", copyDiary.workRecords);
        console.info("workRecords length:", copyDiary.workRecords ? copyDiary.workRecords.length : 'undefined');
        
        // siteIdが存在しない場合は、state.siteSelectedから取得
        if (!copyDiary.siteId) {
          copyDiary.siteId = state.siteSelected;
          console.info("Setting siteId from siteSelected:", copyDiary.siteId);
        }
        
        if (copyDiary.workRecords && copyDiary.workRecords.length > 0) {
          copyDiary.workRecords = copyDiary.workRecords.map(workRecord => {
            const preservedRecord = _.cloneDeep(workRecord);
            
            // サインと画像関連のフィールドをリセット
            preservedRecord.record.sign = "";
            preservedRecord.record.presignedUrl = "";
            preservedRecord.record.objectKey = "";
            
            // 実績値（actual）のみをリセット、予算値（budget）は保持
            if (preservedRecord.record.numberOfPeople) {
              preservedRecord.record.numberOfPeople.actual = "";
              // budget値は保持（変更しない）
            }
            
            return preservedRecord;
          });
          console.info("copyDiary.workRecords AFTER processing:", copyDiary.workRecords);
        } else {
          console.warn("workRecords is empty or undefined, preserving empty array");
          // workRecords が存在しない場合でも、空配列として初期化
          if (!copyDiary.workRecords) {
            copyDiary.workRecords = [];
          }
        }
        copyDiary.copied = true;
        copyDiary.editDateTime = moment(new Date()).toISOString(true);
        copyDiary.diaryPeriod = selectedDiaryPeriod;
        copyDiary.editAs = "budget";
        
        // copyDiary.temperature = { highest: "", lowest: "" };
        
        copyDiary.sitePatrolRecords = [
          { number: 1, label: "openingMeeting", result: null },
          { number: 2, label: "preStartStatus", result: null },
          { number: 3, label: "workClothes", result: null },
          { number: 4, label: "organize", result: null },
          { number: 5, label: "doorWays", result: null },
          { number: 6, label: "smokingRestArea", result: null },
          { number: 7, label: "hygieneStatus", result: null },
          { number: 8, label: "fireUsageStatus", result: null },
          { number: 9, label: "safetySignStatus", result: null },
          { number: 10, label: "guardsArragement", result: null },
          { number: 11, label: "thirdPartyMeasures", result: null },
          { number: 12, label: "curingOpenings", result: null },
          { number: 13, label: "scaffoldInstallation", result: null },
          { number: 14, label: "usingLadders", result: null },
          { number: 15, label: "protruding60cmLadder", result: null },
          { number: 16, label: "heightsWork", result: null },
          { number: 17, label: "flyingFallTreatment", result: null },
          { number: 18, label: "collapseTreatment", result: null },
          { number: 19, label: "craneStatus", result: null },
          { number: 20, label: "constructionMachineStatus", result: null },
          { number: 21, label: "commanderWorkStatus", result: null },
          { number: 22, label: "personelWorkStatus", result: null },
          { number: 23, label: "temporaryElecticity", result: null },
          { number: 24, label: "dangerousMaterialStorage", result: null },
          { number: 25, label: "organicSolveStatus", result: null },
          { number: 26, label: "oxygenMeasure", result: null },
          { number: 27, label: "workDone", result: null },
          { number: 28, label: "workRulesObserved", result: null },
        ];

        copyDiary.signs = resetSignsDiaryBeforeCopy(copyDiary.signs);
        copyDiary.state = "";

        // コピー先の日付情報を設定
        let objMeetingDate = {
          date: dateCopyTo.format("DD"),
          month: parseInt(dateCopyTo.format("MM")),
          year: dateCopyTo.format("YYYY"),
        };
        
        // 日付関連のフィールドを確実にコピー先の日付に設定
        let meetingDateTime = replaceDateMonthYear(
          copyDiary.meetingDateTime,
          objMeetingDate
        );
        copyDiary.meetingDateTime = meetingDateTime.toISOString(true);
        copyDiary.editor = editor;
        copyDiary.dateOfDay = objMeetingDate.date;
        
        // copyDiary.weather = "";
        
        // diaryDateを確実にコピー先の日付に設定
        const newDiaryDate = dateCopyTo.format("YYYY-MM-DD");
        console.info("Setting diaryDate to:", newDiaryDate);
        copyDiary.diaryDate = newDiaryDate;
        const attributeTimeToFormat = [
          "actual.operatingTime.from",
          "actual.operatingTime.to",
          "budget.operatingTime.from",
          "budget.operatingTime.to",
        ];
        //inSite work
        if (copyDiary.co2) {
          for (let i in copyDiary.co2.inSiteWork) {
            const inWork = copyDiary.co2.inSiteWork[i];
            let dateTemp = null;
            for (let path of attributeTimeToFormat) {
              const previousDataTime = _.get(
                inWork.inSiteWork,
                path,
                undefined
              );
              if (previousDataTime != undefined) {
                dateTemp = replaceDateMonthYear(
                  previousDataTime,
                  objMeetingDate
                );
              }
              const pathDataCo2Diary = [i, "inSiteWork", path].join(".");
              _.set(copyDiary.co2.inSiteWork, pathDataCo2Diary, dateTemp);
            }
          }
        }

        copyDiary.windSpeed = {
          speed: "",
          unit: "m",
        };
        //reset signature
        _.set(copyDiary, "supervisorPatrolRecord.supervisor", "");
        _.set(copyDiary, "supervisorPatrolRecord.supervisorPresignedUrl", "");
        _.set(copyDiary, "instructionDuringWork.instructor", "");
        _.set(copyDiary, "instructionDuringWork.instructorPresignedUrl", "");

        for (let i in copyDiary.workRecords) {
          _.set(copyDiary.workRecords[i], "record.sign", "");
          _.set(copyDiary.workRecords[i], "record.presignedUrl", "");
        }
        
        // 処理済みのcopyDiaryをstateに設定
        state.diaryLatest = copyDiary;
        console.info("state.diaryLatest updated with copyDiary:", state.diaryLatest);
      }
    } catch (errors) {
      console.log(">>>>>>>>>>>~errors");
    }
  },
  setMetaDataSite(state, metaDataFromSite) {
    state.metaDataSite = metaDataFromSite;
  },
  updateMetaDataSite(state, { attr, value }) {
    _.set(state.metaDataSite, attr, value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

const serializerSiteRecords = (sites) => {
  const results = Object.assign([], sites.sites);
  return results;
};
const serializerDiariesRecords = (diaries) => {
  let results = [];
  //sort diary revision by editDateTime
  for (let i in diaries) {
    results.push(diaries[i]);
  }

  results.sort(compareEditDateTimeDesc);

  if (results != undefined && results.length > 0) {
    const tempDiaryRevision = Object.assign([], results);
    const diaryLength = tempDiaryRevision.length;

    let listStatePrevious = [];
    listStatePrevious.push(tempDiaryRevision[diaryLength - 1].state);
    const OPERATION_FIELD = ["create", "editing"];
    //set latest item is create
    results[diaryLength - 1]["operation"] = OPERATION_FIELD[0];

    for (let i = diaryLength - 2; i >= 0; i--) {
      let element = tempDiaryRevision[i];
      if (listStatePrevious.includes(element.state)) {
        results[i]["operation"] = OPERATION_FIELD[1];
        continue;
      } else {
        results[i]["operation"] = element.state;
        listStatePrevious.push(element.state);
      }
    }
  }
  return results;
};
const serializerDiariesEditingRecords = (diaries) => {
  let results = [];
  for (const diary of diaries) {
    results.push(diary);
  }
  results.sort(compareDiaryDateAsc);
  return results;
};
const serializerCo2Input = (co2Input) => {
  if (co2Input?.electricity) {
    const result = co2Input;
    if (!result.electricity?.utilizationOfElectricityMenus?.monthlyUses) {
      result["electricity"]["utilizationOfElectricityMenus"]["monthlyUses"] = [
        {
          year: "",
          month: "",
          amount: {
            value: "",
            unit: "kWh",
            isValidateValue: true,
          },
          cost: {
            value: "",
            unit: "JPY",
            isValidateCost: true,
          },
        },
      ];
    }
    result["statusElement"] = {
      electricity: {
        amount: [],
        utilizationOfElectricityMenus: {
          type: "",
          isUsed: false,
          monthlyUses: [
            {
              year: "",
              month: "",
              amount: {
                value: "",
                unit: "kWh",
                isValidateValue: true,
              },
              cost: {
                value: "",
                unit: "JPY",
                isValidateCost: true,
              },
            },
          ],
        },
      },
    };

    //add entry electricity
    for (const i in result.electricity.amount) {
      result.electricity.amount[i]["isFocusYear"] = false;
      result.electricity.amount[i]["isValidateYear"] = true;
      result.electricity.amount[i]["isFocusMonth"] = false;
      result.electricity.amount[i]["isValidateMonth"] = true;
      result.electricity.amount[i]["isFocusValue"] = false;
      result.electricity.amount[i]["isValidateValue"] = true;
      result.electricity.amount[i]["isFocusCost"] = false;
      result.electricity.amount[i]["isValidateCost"] = true;
    }
    //add entry utilizationOfElectricityMenus
    for (const i in result.electricity.utilizationOfElectricityMenus
      .monthlyUses) {
      result.electricity.utilizationOfElectricityMenus.monthlyUses[i][
        "isFocusYear"
      ] = false;
      result.electricity.utilizationOfElectricityMenus.monthlyUses[i][
        "isValidateYear"
      ] = true;
      result.electricity.utilizationOfElectricityMenus.monthlyUses[i][
        "isFocusMonth"
      ] = false;
      result.electricity.utilizationOfElectricityMenus.monthlyUses[i][
        "isValidateMonth"
      ] = true;
      result.electricity.utilizationOfElectricityMenus.monthlyUses[i].amount[
        "isFocusValue"
      ] = false;
      result.electricity.utilizationOfElectricityMenus.monthlyUses[i].amount[
        "isValidateValue"
      ] = true;
      result.electricity.utilizationOfElectricityMenus.monthlyUses[i].cost[
        "isFocusCost"
      ] = false;
      result.electricity.utilizationOfElectricityMenus.monthlyUses[i].cost[
        "isValidateCost"
      ] = true;
    }
    //add entry kerosene
    for (const i in result.kerosene.amount) {
      result.kerosene.amount[i]["isFocusYear"] = false;
      result.kerosene.amount[i]["isValidateYear"] = true;
      result.kerosene.amount[i]["isFocusMonth"] = false;
      result.kerosene.amount[i]["isValidateMonth"] = true;
      result.kerosene.amount[i]["isFocusValue"] = false;
      result.kerosene.amount[i]["isValidateValue"] = true;
      result.kerosene.amount[i]["isFocusCost"] = false;
      result.kerosene.amount[i]["isValidateCost"] = true;
    }
    //add entry heavyOil
    for (const i in result.heavyOil.amount) {
      result.heavyOil.amount[i]["isFocusYear"] = false;
      result.heavyOil.amount[i]["isValidateYear"] = true;
      result.heavyOil.amount[i]["isFocusMonth"] = false;
      result.heavyOil.amount[i]["isValidateMonth"] = true;
      result.heavyOil.amount[i]["isFocusValue"] = false;
      result.heavyOil.amount[i]["isValidateValue"] = true;
      result.heavyOil.amount[i]["isFocusCost"] = false;
      result.heavyOil.amount[i]["isValidateCost"] = true;
    }
    //water intake
    for (const i in result.water.waterIntake.amount) {
      result.water.waterIntake.amount[i]["isFocusYear"] = false;
      result.water.waterIntake.amount[i]["isValidateYear"] = true;
      result.water.waterIntake.amount[i]["isFocusMonth"] = false;
      result.water.waterIntake.amount[i]["isValidateMonth"] = true;
      result.water.waterIntake.amount[i]["isFocusValue"] = false;
      result.water.waterIntake.amount[i]["isValidateValue"] = true;
      result.water.waterIntake.amount[i]["isFocusCost"] = false;
      result.water.waterIntake.amount[i]["isValidateCost"] = true;
    }
    //water drainage destination
    for (const i in result.water.drainageDestination.amount) {
      result.water.drainageDestination.amount[i]["isFocusYear"] = false;
      result.water.drainageDestination.amount[i]["isValidateYear"] = true;
      result.water.drainageDestination.amount[i]["isFocusMonth"] = false;
      result.water.drainageDestination.amount[i]["isValidateMonth"] = true;
      result.water.drainageDestination.amount[i]["isFocusValue"] = false;
      result.water.drainageDestination.amount[i]["isValidateValue"] = true;
    }
    //add attribute for other group
    for (const attrName of ["installSolarPanelsOnSite"]) {
      result.others[attrName].amount["isFocus"] = false;
      result.others[attrName].amount["isValidate"] = true;
    }
    for (const attrName of ["installWindPowerGenerationOnSite"]) {
      result.others[attrName].usage["isFocus"] = false;
      result.others[attrName].usage["isValidate"] = true;
    }
    for (const i in result.others.useOfCementAlternative.monthlyUses) {
      result.others.useOfCementAlternative.monthlyUses[i]["isFocusYear"] =
        false;
      result.others.useOfCementAlternative.monthlyUses[i]["isValidateYear"] =
        true;
      result.others.useOfCementAlternative.monthlyUses[i]["isFocusMonth"] =
        false;
      result.others.useOfCementAlternative.monthlyUses[i]["isValidateMonth"] =
        true;
      result.others.useOfCementAlternative.monthlyUses[i].amount[
        "isFocusValue"
      ] = false;
      result.others.useOfCementAlternative.monthlyUses[i].amount[
        "isValidateValue"
      ] = true;
    }
    for (const i in result.othersMonthlyUses?.alterNativeFuel) {
      result.othersMonthlyUses.alterNativeFuel[i]["isFocusYear"] = false;
      result.othersMonthlyUses.alterNativeFuel[i]["isValidateYear"] = true;
      result.othersMonthlyUses.alterNativeFuel[i]["isFocusMonth"] = false;
      result.othersMonthlyUses.alterNativeFuel[i]["isValidateMonth"] = true;
      result.othersMonthlyUses.alterNativeFuel[i].amount["isFocusValue"] =
        false;
      result.othersMonthlyUses.alterNativeFuel[i].amount["isValidateValue"] =
        true;
    }
    for (const i in result.othersMonthlyUses?.alterNativeEnergy) {
      result.othersMonthlyUses.alterNativeEnergy[i]["isFocusYear"] = false;
      result.othersMonthlyUses.alterNativeEnergy[i]["isValidateYear"] = true;
      result.othersMonthlyUses.alterNativeEnergy[i]["isFocusMonth"] = false;
      result.othersMonthlyUses.alterNativeEnergy[i]["isValidateMonth"] = true;
      result.othersMonthlyUses.alterNativeEnergy[i].amount["isFocusValue"] =
        false;
      result.othersMonthlyUses.alterNativeEnergy[i].amount["isValidateValue"] =
        true;
    }
    return result;
  } else {
    return co2InputDefault();
  }
};
const co2InputDefault = () => {
  return {
    electricity: {
      amount: [],
      utilizationOfElectricityMenus: {
        type: "",
        isUsed: false,
        monthlyUses: [
          {
            year: "",
            month: "",
            isValidateYear: true,
            isValidateMonth: true,
            amount: {
              value: "",
              unit: "kWh",
              isValidateValue: true,
            },
            cost: {
              value: "",
              unit: "JPY",
              isValidateCost: true,
            },
          },
        ],
      },
    },
    water: {
      waterIntake: {
        type: "",
        otherType: {},
        isUsed: false,
        amount: [],
      },
      drainageDestination: {
        type: "",
        otherType: {},
        isUsed: false,
        amount: [],
      },
    },
    kerosene: {
      amount: [],
    },
    heavyOil: {
      amount: [],
    },
    diesel: {},
    others: {
      useOfB5: {
        isUsed: false,
        amount: {
          value: "",
          unit: "ℓ",
          isValidate: true,
        },
      },
      useOfB100: {
        isUsed: false,
        amount: {
          value: "",
          unit: "ℓ",
          isValidate: true,
        },
      },
      useGTLFuel: {
        isUsed: false,
        amount: {
          value: "",
          unit: "ℓ",
          isValidate: true,
        },
      },
      installSolarPanelsOnSite: {
        isUsed: false,
        amount: {
          value: "",
          unit: "kW",
          isValidate: true,
        },
      },
      installWindPowerGenerationOnSite: {
        isUsed: false,
        usage: {
          value: "",
          unit: "kW",
          isValidate: true,
        },
      },
      useOfRenewableEnergy: "",
      useOfCementAlternative: {
        isUsed: false,
        monthlyUses: [
          {
            year: "",
            month: "",
            isValidateYear: true,
            isValidateMonth: true,
            amount: {
              value: "",
              unit: "㎥",
              isValidateValue: true,
            },
          },
        ],
      },
    },
    othersMonthlyUses: {
      alterNativeFuel: [
        {
          type: "",
          year: "",
          month: "",
          isValidateYear: true,
          isValidateMonth: true,
          amount: {
            isValidateValue: true,
            value: "",
            unit: "L",
          },
        },
      ],
      alterNativeEnergy: [
        {
          type: "",
          year: "",
          month: "",
          isValidateYear: true,
          isValidateMonth: true,
          amount: {
            isValidateValue: true,
            value: "",
            unit: "kW",
          },
        },
      ],
    },
  };
};
const replaceDateMonthYear = (dateChangeFrom, objMeetingDate) => {
  const dateChangeTo = moment(dateChangeFrom);
  dateChangeTo.set("date", objMeetingDate.date);
  dateChangeTo.set("month", objMeetingDate.month - 1);
  dateChangeTo.set("year", objMeetingDate.year);
  return dateChangeTo;
};
